export default __webpack_public_path__ + "static/media/sysmatch-esta-a-recrutar-it-08.2b039dad.png";